import { Banner } from "components/common/composite";
import { useTranslation } from "translations";
import { tw } from "utils/tw";

export default (): React.JSX.Element | null => {
  const { t } = useTranslation("common");

  const isOutdated = typeof Promise.withResolvers === "undefined";
  // REACT_APP_ANNOUNCE_NEW_APP=true (build-time, like every REACT_APP_* var):
  // this is the old Payout Partner now; point people at the new one. pop-core
  // carries the mirror flag (ANNOUNCE_OLD_APP) pointing back here.
  const announceNewApp = process.env.REACT_APP_ANNOUNCE_NEW_APP === "true";
  const newAppUrl = "https://app.payoutpartner.com";

  return (
    <div className={tw("flex", "flex-col", "gap-px")}>
      {announceNewApp && (
        <Banner
          rounded={false}
          variant="info"
          title={t(
            "bannerSection.newApp.title",
            "Payout Partner has a new home"
          )}
          body={t(
            "bannerSection.newApp.body",
            "The new Payout Partner is at app.payoutpartner.com — same account, same sign-in. This site stays up for a while."
          )}
          actions={[
            {
              id: "banner_section-go_to_new_app",
              label: t("bannerSection.newApp.action", "Go to the new site"),
              to: newAppUrl,
              isExternal: true,
            },
          ]}
        />
      )}
      {isOutdated && (
        <Banner
          rounded={false}
          variant="warning"
          title={t(
            "bannerSection.outdated.title",
            "Looks like you are using an outdated browser"
          )}
          body={t(
            "bannerSection.outdated.body",
            "Manymore functions best on the newest browser versions, and we recommend that you update your browser."
          )}
        />
      )}
    </div>
  );
};
